import React, { lazy, Suspense } from 'react';

import { managementRoutes, stakeholderManagementRoutes, stakeholderOperationRoutes } from '../navigation';
import { useCurrentPortal } from '../hooks';
import { Loader } from '../components/common';
import ErrorBoundary from '../components/common/ErrorBoundary/index';
import { isShortageHost } from '../hooks/isShortageHost';

const ManagementApp = lazy(() => import('./ManagementApp'));
const StakeholderManagementApp = lazy(() => import('./StakeholderManagementApp'));
const StakeholderOperationApp = lazy(() => import('./StakeholderOperationApp'));

const App = () => {
  const shortageHost = isShortageHost();
  const currentPortal = `/${useCurrentPortal()}`;

  return (
    <ErrorBoundary currentPortal={ currentPortal }>
      <Suspense fallback={ <Loader /> }>
        {currentPortal === managementRoutes.MANAGEMENT
                         && <ManagementApp />}

        {(currentPortal === stakeholderManagementRoutes.STAKEHOLDER_MANAGEMENT && !shortageHost)
                        && <StakeholderManagementApp />}

        {(currentPortal === stakeholderOperationRoutes.STAKEHOLDER_OPERATION)
                         && <StakeholderOperationApp />}
      </Suspense>
    </ErrorBoundary>
  );
};
export default App;


// import React, { lazy, Suspense, useState, useEffect } from 'react';

// import { managementRoutes, stakeholderManagementRoutes, stakeholderOperationRoutes } from '../navigation';
// import { useCurrentPortal } from '../hooks';
// import { Loader } from '../components/common';
// import ErrorBoundary from '../components/common/ErrorBoundary/index';
// import { isShortageHost } from '../hooks/isShortageHost';
// import {PageNotFound} from '../components/common/ErrorPages/PageNotFound';
// import { NotAuthorized } from '../components/common/ErrorPages/NotAuthorized';
// import withErrorHandling from '../app/ErrorHandlingHOC';

// const ManagementApp = lazy(() => import('./ManagementApp'));
// const StakeholderManagementApp = lazy(() => import('./StakeholderManagementApp'));
// const StakeholderOperationApp = lazy(() => import('./StakeholderOperationApp'));

// const App = () => {
//   const [errorStatus, setErrorStatus] = useState(null);
//   const shortageHost = isShortageHost();
//   const currentPortal = `/${useCurrentPortal()}`;

//   const handleError = (error) => {
//     if (error.response) {
//       if (error.response.status === 404) {
//         setErrorStatus(404);
//       } else if (error.response.status === 403) {
//         setErrorStatus(403);
//       }
//     } else {
//       setErrorStatus(null);
//     }
//   };

//   useEffect(() => {
//     // Reset error status when currentPortal changes
//     setErrorStatus(null);
//   }, [currentPortal]);

//   if (errorStatus === 404) {
//     return <PageNotFound />;
//   }

//   if (errorStatus === 403) {
//     return <NotAuthorized />;
//   }

//   const ManagementAppWithErrorHandling = withErrorHandling(ManagementApp, handleError);
//   const StakeholderManagementAppWithErrorHandling = withErrorHandling(StakeholderManagementApp, handleError);
//   const StakeholderOperationAppWithErrorHandling = withErrorHandling(StakeholderOperationApp, handleError);


//   return (
//     <ErrorBoundary currentPortal={currentPortal}>
//       <Suspense fallback={<Loader />}>
//         {currentPortal === managementRoutes.MANAGEMENT && (
//           <ManagementAppWithErrorHandling/>
//         )}
//         {currentPortal === stakeholderManagementRoutes.STAKEHOLDER_MANAGEMENT &&
//           !shortageHost && (
//             <StakeholderManagementAppWithErrorHandling/>
//           )}
//         {currentPortal === stakeholderOperationRoutes.STAKEHOLDER_OPERATION && (
//           <StakeholderOperationAppWithErrorHandling/>
//         )}
//       </Suspense>
//     </ErrorBoundary>
//   );
// };

// ;
// export default App;


